import { ISector } from '../types/Monitor';

export const formatSectorsTrackNumbers = (sectors: ISector[]) =>
  sectors.map((sector) => ({
    ...sector,
    customerName: sector.customerName,
    trackNumber: sector.trackNumber.slice(-2),
  }));
